// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g3-0";
export var actionModalContentContainer = "_g3-1";
export var createTagButton = "_g3-2";
export var footerContainer = "_g3-7";
export var fullWidthDivider = "_g3-3";
export var hasCreateTagButton = "_g3-4";
export var noCreateTagButton = "_g3-5";
export var tagsContainer = "_g3-6";
export var tagsModalContentContainer = "_g3-8";